
import Button from '../../../components/base/Button';

export default function ZollerAdvantagesSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            ZOLLERが選ばれる理由
          </h2>
          <p className="text-xl text-gray-600">
            venturion / smile 共通価値
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <div className="space-y-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-black font-bold">1</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    一発良品の実現（必要時は"確認1回"のみ）
                  </h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• 工具長・径に加え、角度・コーナーRまで高精度測定</li>
                    <li>• ±2μmレベルの繰り返し精度</li>
                    <li>• H7公差のボーリングも追い込み加工ゼロへ</li>
                    <li>• 高い測定再現性が製品品質アップにつながる</li>
                  </ul>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-black font-bold">2</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    "誰でも"高精度
                  </h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• 直感UI＋セットアップシート（ワーク別ツールレシピ）</li>
                    <li>• BT／HSK混在もクイックアダプターで即切替</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <div className="space-y-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-black font-bold">3</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    NCへワンプッシュでデータ転送
                  </h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• 手書き→NC入力を廃止しミスゼロ</li>
                    <li>• 各種制御装置と接続（Fanuc / Mitsubishi / Heidenhain / Siemens ほか）</li>
                    <li>• 測定データ転送機能により、工具段取り時間大幅減</li>
                  </ul>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <span className="text-black font-bold">4</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    試し削りの大幅圧縮
                  </h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• 段取りの裏取りをプリセッター側で完了</li>
                    <li>• 機械は"削ること"だけに専念＝稼働率UP</li>
                    <li>• 稼働率UPに加え、不良率DOWNで納期短縮に大きく貢献</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center">
          <Button variant="primary" size="lg" onClick={scrollToContact}>
            <i className="ri-play-circle-line mr-2"></i>
            デモンストレーションを予約
          </Button>
        </div>
      </div>
    </section>
  );
}
